import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export default function Home() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <div className="min-h-screen">
          {/* Seu conteúdo principal será renderizado aqui */}
        </div>
      </BrowserRouter>
    </QueryClientProvider>
  );
}